import { Avatar, Box, Button, Card, CardActions, CardContent, CardHeader, Divider, Stack, Typography, Zoom } from "@mui/material";
import { blue, } from "@mui/material/colors";
import { useEffect, useState } from "react";
import Create from "./Create";
import partialDelete from './PartialDelete'

function Inbox(props) {

    const {setMain} = props

    const [messages, setMessages] = useState([])

    const receivedMessages = messages.filter(msg=>{return msg.label==='inbox' && !msg.deleted ? true:false})

    useEffect(()=>async ()=>{
        const response =await fetch('http://127.0.0.1:8000/messenger/messages/', {
            mode:'cors',
            method: 'GET',
                  
          })          
          const fetcher =  response.body.getReader();
          let data = [];
          let receivedLength = 0;
          while(true)  {
              const {value, done} = await fetcher.read()
              
              if(done){
                  break 
                        }

                        data.push(value)
                        receivedLength += value.length;

          }
          let chunksAll = new Uint8Array(receivedLength); 
          let position = 0;
          for(let chunk of data) {
            chunksAll.set(chunk, position); 
            position += chunk.length;
          }    
          let result = new TextDecoder("utf-8").decode(chunksAll);

          let finalData = JSON.parse(result);
          setMessages(finalData)
          console.log(finalData);
          
    },[])

    const handleDelete = (id) => {
        const filteredMessages = messages.map(mesg=>{
          if(id===mesg.id){
            mesg.deleted=true;
          }
          return mesg;
        })
        setMessages(filteredMessages)
        const params =  {
          url:'http://127.0.0.1:8000/messenger/messages/',
          method:'PATCH',
          params :{
            id:id,
            type:'delete',
          }
        }
        const results = partialDelete(params)
      }
    
    
      const handleForward = (text) => {
        setMain(<Create  text={text} />);
      }
 

    return (<Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack>
            <Typography variant="h6">Inbox</Typography>
            <Divider variant="middle"/>
            {receivedMessages.length>0 ?  receivedMessages.map(message=>{
            return(
                <Card elevation={3} key={message.id} sx={{mt:1,mb:1}}>
                    <CardHeader 
                    sx={{bgcolor:blue[200]}} 
                    avatar={<Avatar sx={{bgcolor:"red"}}>I</Avatar>}
                    title ={message.date}
                    subheader={<Typography variant="h6">{message.firstName} {message.lastName}</Typography>}/>
                    
                    <CardContent>
                        <Typography>{message.message}</Typography>
                    </CardContent>
                    <CardActions sx={{display:'flex', justifyContent:'space-evenly'}}>
                        <Button variant="outlined" onClick={()=>handleForward(message.message)} >Forward</Button>
                        <Button variant="outlined" disabled={message.replyable}>Reply</Button>
                        <Button variant="outlined" color="error" onClick={()=>handleDelete(message.id)}>Delete</Button>
                    </CardActions>
                </Card>
            )
        }):<Box display={'flex'} justifyContent={'center'} mt={2}><Typography>No Messages</Typography></Box>}



    </Stack>
    </Zoom>);
}

export default Inbox;


async function apiLoader(parameters){

  let results = {}
  let  params = parameters.params
  
const response = await fetch(
  parameters.url,
  {
    mode: "cors",
    method: parameters.method,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
    body: new URLSearchParams(params)      
  }
);

 results.status = response.status
const fetcher = response.body.getReader();
let data = [];
let receivedLength = 0;
while (true) {
  const { value, done } = await fetcher.read();

  if (done) {
    break;
  }

  data.push(value);
  receivedLength += value.length;
}
let chunksAll = new Uint8Array(receivedLength);
let position = 0;
for (let chunk of data) {
  chunksAll.set(chunk, position);
  position += chunk.length;
}
let result = new TextDecoder("utf-8").decode(chunksAll);

let finalData = JSON.parse(result);
results.data = finalData;
return results;
}